export default "__VITE_ASSET__Bu5TiexZ__"